export {default as bandSpace} from './src/bandSpace';
export {default as scale} from './src/scales';
export {interpolate, interpolateRange, scaleFraction} from './src/interpolate';
export {scheme, schemeDiscretized} from './src/schemes';
export {timeInterval, utcInterval} from './src/timeInterval';
export {scaleImplicit} from 'd3-scale';



// WEBPACK FOOTER //
// ./~/vega-scale/index.js